import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './StatusBanner.scss';

export const STATUS_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  ERROR: 'error',
};

const STATUS_ICON = {
  [STATUS_TYPES.INFO]: 'svg-info-circle',
  [STATUS_TYPES.SUCCESS]: 'svg-icon-check',
  [STATUS_TYPES.ERROR]: 'svg-exclamation',
};

const StatusBanner = ({ status, className, children }) => {
  if (!status || !children) return null;

  return (
    <div className={classnames('status-banner', `banner-${status}`, className)}>
      <span className={classnames('banner-icon', STATUS_ICON[status])} />
      <span className="banner-message">{children}</span>
    </div>
  );
};

StatusBanner.propTypes = {
  status: PropTypes.oneOf(Object.values(STATUS_TYPES)),
  className: PropTypes.string,
  children: PropTypes.node,
};

StatusBanner.defaultProps = {
  status: null,
  className: '',
  children: null,
};

export default StatusBanner;

